module.exports = __webpack_public_path__ + "static/media/Charing Cross Pavillion c. 1910s Victoria statue.107a3f05.jpg";